import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmationService } from 'primeng/api';
import { LectureGroupsComponent } from './lecture-groups.component';
import { LectureGroupsListComponent } from './lecture-groups-list/lecture-groups-list.component';
import { LectureGroupFormComponent } from './lecture-group-form/lecture-group-form.component';
import { LectureGroupAddStudentsComponent } from './lecture-group-add-students/lecture-group-add-students.component';

@NgModule({
  declarations: [
    LectureGroupsComponent,
    LectureGroupsListComponent,
    LectureGroupFormComponent,
    LectureGroupAddStudentsComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    CheckboxModule,
    ConfirmDialogModule,
    DropdownModule,
    InputTextModule,
    MultiSelectModule,
    TableModule,
    TabViewModule,
    TooltipModule,
  ],
  providers: [ConfirmationService],
})
export class LectureGroupsModule {}
